export enum ScrollDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ArrowScrollerProps {
  children: React.ReactNode;
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
  scrollAmount: number;
}
